export default __webpack_public_path__ + "assets/illustrations/trophy_emoji.c711f29033de6ee313be9fa358e9aade.png";